import { render, staticRenderFns } from "./Economy.vue?vue&type=template&id=44b35c9c&scoped=true&"
import script from "./Economy.vue?vue&type=script&lang=js&"
export * from "./Economy.vue?vue&type=script&lang=js&"
import style0 from "./Economy.vue?vue&type=style&index=0&id=44b35c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b35c9c",
  null
  
)

export default component.exports